// © Microsoft Corporation. All rights reserved.

import { DesignSystem } from "@microsoft/fast-components-styles-msft";

export const FollowButtonSuperAppStyles = (config: DesignSystem) => ({
    followButtonSuperAppContainer: {
    }
});